<template>
  <el-dropdown trigger="click" placement="bottom" @command="onDropdownChange">
    <el-button class="button-dropdown" type="text">
      <span>{{ list[value]['name'] }}</span>
      <i class="el-icon-caret-bottom el-icon--right"></i>
    </el-button>
    <el-dropdown-menu slot="dropdown" class="dropdown-menu">
      <el-dropdown-item v-for="(item, i) in list" :key="i" :command="i">
        {{ item.name }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
export default {
  name: 'MenuSort',
  props: {
    // 列表 [{ name: string, value: any }]
    list: Array,
    // 当前值索引
    value: Number,
  },
  methods: {
    /**
     * 下拉选项发生变化
     */
    onDropdownChange(command) {
      this.$emit('input', command);
      this.$emit('change', command);
    },
  },
};
</script>
<style scoped lang="scss">
.button-dropdown {
  color: var(--text-color-3);
}
</style>
